import { SceneWithUserNames } from '../../../../types/scene.types';
import { SortConfig } from '../BreakdownMain.types';
import { sortScenes } from './SceneCodeUtils';

/**
 * 从当前 scenes 保留「尚未填写场号」的 temp-* 占位行。
 * 与 ScenesTable 原 handleCacheUpdate 逻辑一致。
 */
export function extractPlaceholderScenes(
  currentScenes: SceneWithUserNames[]
): SceneWithUserNames[] {
  return currentScenes.filter((s) => {
    if (!s.sceneID.startsWith('temp-')) return false;
    const sceneCode = s.sceneCode == null ? '' : String(s.sceneCode).trim();
    return sceneCode === '';
  });
}

/**
 * 合并缓存场次与本地占位行，并按 sortConfig 排序。
 */
export function mergeScenesFromCache(
  cacheScenes: SceneWithUserNames[],
  currentScenes: SceneWithUserNames[],
  sortConfig: SortConfig
): SceneWithUserNames[] {
  const placeholderScenes = extractPlaceholderScenes(currentScenes);
  const mergedScenes = [...cacheScenes, ...placeholderScenes];
  return sortScenes(mergedScenes, sortConfig.key, sortConfig.direction);
}
